import React, {useContext, useState, useEffect} from 'react';
import toast from "react-hot-toast";
import { eventService } from "../../Services/eventService";
import Moment from "react-moment";
import { useParams } from "react-router";
import { UserContext } from "../../Contexts/UserContext";
import EditGeoJsonModal from './EditGeoJsonModal';
import EditEventModal from './EditEventModal';
import DeleteConfirmModal from '../DeleteConfirmModal';
import { Link } from 'react-router-dom';
import EditImageModal from './EditImageModal';

const AoiEvents = (props) => {
    let { aoiId, eventId } = useParams();
    const [events, setEvents] = useState([]);
    const [tlineId, setTlineId] = useState(eventId);
    const {geoJsonTypes} = useContext(UserContext);

    const [editEvent, setEditEvent] = useState({});
    const [showEditEvent, setShowEditEvent] = useState(false);
    const [showDeleteEvent, setShowDeleteEvent] = useState(false);

    const [editGeoJson, setEditGeoJson] = useState({});
    const [showEditGeoJsons, setShowEditGeoJsons] = useState(false);
    const [showDeleteGeoJson, setShowDeleteGeoJson] = useState(false);

    const [editImage, setEditImage] = useState({});
    const [showEditImage, setShowEditImage] = useState(false);
    const [showDeleteImage, setShowDeleteImage] = useState(false);

    useEffect(() => {
        reloadEvents();
    }, [aoiId]);

    const reloadEvents = () => {
        eventService.getEventsByAoiId(aoiId).then((data) => {
            console.log(data);
            setEvents(data);
        });
    };

    const handleDownload = (data, fileName) => {
        const blob = new Blob([data], { type: 'text/json' });
        const url = URL.createObjectURL(blob);
    
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName + ".geojson"; // <-- the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    
        URL.revokeObjectURL(url); // cleanup
    };

    const startEditGeoJson = (event, geoJson) => {
        setEditEvent(event);
        setEditGeoJson(geoJson);
        setShowEditGeoJsons(true);
    };

    const startEditEvent = (event) => {
        setEditEvent(event);
        setShowEditEvent(true);
    };

    const startEditImage = (event, image) => {
        setEditEvent(event);
        setEditImage(image);
        setShowEditImage(true);
    };

    const startDeleteEvent = (event) => {
        setEditEvent(event);
        setShowDeleteEvent(true);
    };

    const startDeleteGeoJson = (event, geoJson) => {
        setEditEvent(event);
        setEditGeoJson(geoJson);
        setShowDeleteGeoJson(true);
    };

    const startDeleteImage = (event, image) => {
        setEditEvent(event);
        setEditImage(image);
        setShowDeleteImage(true);
    };

    const onDeleteEvent = (deleteEvent) => {
        if(!!deleteEvent) {
            eventService.deleteEvent(editEvent.eventId).then((e) => {
                toast.success("Successfully deleted the event");
                reloadEvents();
            }).catch((e) => {
                toast.error("Unable to delete the event");
            });
        }
        setShowDeleteEvent(false);
    };

    const onDeleteGeoJson = (deleteGeoJson) => {
        if(!!deleteGeoJson) {
            eventService.deleteGeoJson(editGeoJson.eventGeoJsonId).then((e) => {
                toast.success("Successfully deleted GeoJson");
                reloadEvents();
            }).catch((e) => {
                toast.error("Unable to delete the GeoJson");
            });
        }
    };

    const onDeleteImage = (deleteImage) => {
        if(!!deleteImage) {
            eventService.deleteImage(editImage.eventImageId).then((e) => {
                toast.success("Successfully deleted Image");
                reloadEvents();
            }).catch((e) => {
                toast.error("Unable to delete the Image");
            });
        }
    };

    const renderGeoJsons = (e) => {
        return <div style={{"border": "2px solid black", "margin": "10px", "padding": "10px"}}>
                <div>Geo Jsons <button onClick={() => startEditGeoJson(e, null)}>Add GeoJson</button></div>
                {
                    e.geoJsons.map((g) => {
                        let name = g.name ?? "Unnamed";
                        let geoJsonType = geoJsonTypes.find(t => t.geoJsonTypeId == g.geoJsonTypeId);
                        return <div key={g.eventGeoJsonId}>
                                    <div>Name : {name}</div>
                                    <div>GeoJsonType: {geoJsonType?.name}</div>
                                    <button onClick={() => handleDownload(g.geoJson, name)}>Download</button>
                                    <button onClick={() => startEditGeoJson(e, g)}>Edit</button>
                                    <button onClick={() => startDeleteGeoJson(e, g)}>Delete</button>
                                </div>;
                    })
                }
                </div>;
    };

    const renderImages = (e) => {
        return <div style={{"border": "2px solid black", "margin": "10px", "padding": "10px"}}>
                <div>Images <button onClick={() => startEditImage(e, null)}>Add Image</button></div>
                {
                    e.images && e.images.map((g) => {
                        return <div key={g.eventImageId}>
                                <div>Name : {g.name ? g.name : "Unnamed"}</div>
                                <Link to={`${g.imagePath}`} target="_blank">View</Link>
                                <button onClick={() => startEditImage(e, g)}>Edit</button>
                                <button onClick={() => startDeleteImage(e, g)}>Delete</button>
                            </div>;
                    })
                }
                </div>;
    };

    return (
        <div className="form-content page-body event-form">
            <div>
                <h3>Events - {props.aoi?.name}</h3>
                <div className='event-form-btns'>
                    <button type="button" className="btn btn-primary" aria-label="Submit" onClick={() => startEditEvent(null)}>
                        Create Event
                    </button>
                   
                        <Link to={`/timeline/${aoiId}`}>View AOI</Link>
  
                </div>
                <div>
                    {
                        events.map((e) => {
                            if(tlineId != null && tlineId != e.eventId)
                                return <></>;
                            return <div key={e.eventId}>
                                    {
                                        tlineId != null &&
                                        <div>Filtering the events: <Link to={`/manageevents/${aoiId}`} onClick={() => setTlineId(null)}>Clear the filters</Link></div>
                                    }
                                    <div style={{"border": "2px solid black", "margin": "10px", "padding": "10px"}}>
                                        <div>Event Date: <span><Moment date={e.eventDate} format={"Do MMMM YYYY"}></Moment> </span></div> 
                                        <button onClick={() => startEditEvent(e)}>Edit Event</button>
                                        <button onClick={() => startDeleteEvent(e)}>Delete Event</button>
                                        <div>Name: {e.name}</div>
                                        <div>Internal Event: {e.isInternal.toString()}</div>
                                        <div>Credits: {e.imageCredits}</div>
                                        {
                                            renderGeoJsons(e)
                                        }
                                        {
                                            renderImages(e)
                                        }
                                    </div>
                                </div>;

                        })
                    }
                </div>
            </div>
            {
                showEditGeoJsons && <EditGeoJsonModal setShow={setShowEditGeoJsons} geoJson={editGeoJson} eventId={editEvent.eventId} reload={reloadEvents} />
            }
            {
                showEditImage && <EditImageModal setShow={setShowEditImage} image={editImage} eventId={editEvent.eventId} reload={reloadEvents} />
            }
            {
                showEditEvent && <EditEventModal setShow={setShowEditEvent} aoiId={aoiId} event={editEvent} reload={reloadEvents}/>
            }
            {
                showDeleteEvent && 
                <DeleteConfirmModal 
                    setShowDeleteConfirmModal={setShowDeleteEvent} 
                    title="Confirm Event Delete"
                    confirmByInput={true}
                    confirmValue={"Delete " + (editEvent.name ?? "Event")}
                    inputLabel={
                        `Do you want to Delete the Event <b>${editEvent.name ?? ""}</b> ?<br><br>
                        Type <b>${"Delete " + (editEvent.name ?? "Event")}</b> to delete the Event: `
                    }
                    onConfirmDelete={onDeleteEvent}
                    onCancel={()=>onDeleteEvent(false)}
                />
            }
            {
                showDeleteGeoJson &&
                <DeleteConfirmModal 
                    setShowDeleteConfirmModal={setShowDeleteGeoJson} 
                    title="Confirm GeoJson Delete"
                    confirmByInput={true}
                    confirmValue={"Delete " + (editGeoJson.name ?? "GeoJson")}
                    inputLabel={
                        `Do you want to Delete the GeoJson <b>${editGeoJson.name ?? ""}</b> ?<br><br>
                        Type <b>${"Delete " + (editGeoJson.name ?? "GeoJson")}</b> to delete the GeoJson: `
                    }
                    onConfirmDelete={onDeleteGeoJson}
                    onCancel={()=>onDeleteGeoJson(false)}
                />
            }
            {
                showDeleteImage &&
                <DeleteConfirmModal 
                    setShowDeleteConfirmModal={setShowDeleteImage} 
                    title="Confirm Image Delete"
                    confirmByInput={true}
                    confirmValue={"Delete " + (editImage.name ?? "Image")}
                    inputLabel={
                        `Do you want to Delete the Image <b>${editImage.name ?? ""}</b> ?<br><br>
                        Type <b>${"Delete " + (editImage.name ?? "Image")}</b> to delete the Image: `
                    }
                    onConfirmDelete={onDeleteImage}
                    onCancel={()=>onDeleteImage(false)}
                />
            }
        </div>
    );
}

export default AoiEvents;